function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevrijLogoCloud004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sendpoint"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sendpoint",
    transform: "matrix(2.47866,0,0,2.47866,-56.2456,-154.917)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,117,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.043,-0.368C0.043,-0.293 0.091,-0.247 0.189,-0.224L0.272,-0.205C0.329,-0.192 0.348,-0.172 0.348,-0.139C0.348,-0.097 0.309,-0.071 0.245,-0.071C0.181,-0.071 0.144,-0.097 0.134,-0.151L0.03,-0.151C0.04,-0.053 0.117,0.01 0.245,0.01C0.366,0.01 0.454,-0.055 0.454,-0.148C0.454,-0.223 0.414,-0.264 0.309,-0.288L0.225,-0.307C0.169,-0.32 0.146,-0.342 0.146,-0.374C0.146,-0.415 0.184,-0.443 0.241,-0.443C0.3,-0.443 0.337,-0.412 0.343,-0.362L0.442,-0.362C0.438,-0.457 0.361,-0.523 0.241,-0.523C0.123,-0.523 0.043,-0.46 0.043,-0.368Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,145.989,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.393,-0.151C0.378,-0.106 0.334,-0.076 0.274,-0.076C0.189,-0.076 0.136,-0.135 0.136,-0.224L0.136,-0.23L0.499,-0.23L0.499,-0.267C0.499,-0.422 0.41,-0.523 0.267,-0.523C0.122,-0.523 0.029,-0.416 0.029,-0.254C0.029,-0.092 0.121,0.01 0.271,0.01C0.389,0.01 0.478,-0.057 0.493,-0.151L0.393,-0.151ZM0.267,-0.438C0.341,-0.438 0.391,-0.383 0.393,-0.304L0.136,-0.304C0.142,-0.382 0.193,-0.438 0.267,-0.438Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,177.675,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.052,-0L0.158,-0L0.158,-0.299C0.158,-0.379 0.206,-0.432 0.28,-0.432C0.353,-0.432 0.389,-0.389 0.389,-0.312L0.389,-0L0.495,-0L0.495,-0.333C0.495,-0.45 0.43,-0.522 0.317,-0.522C0.238,-0.522 0.183,-0.486 0.155,-0.428L0.153,-0.428L0.153,-0.514L0.052,-0.514L0.052,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,210.357,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.245,0.009C0.32,0.009 0.378,-0.029 0.409,-0.087L0.411,-0.087L0.411,-0L0.513,-0L0.513,-0.705L0.407,-0.705L0.407,-0.428L0.405,-0.428C0.376,-0.485 0.318,-0.522 0.244,-0.522C0.115,-0.522 0.029,-0.419 0.029,-0.257C0.029,-0.095 0.115,0.009 0.245,0.009ZM0.273,-0.433C0.354,-0.433 0.408,-0.363 0.408,-0.257C0.408,-0.149 0.354,-0.081 0.273,-0.081C0.189,-0.081 0.137,-0.148 0.137,-0.257C0.137,-0.365 0.189,-0.433 0.273,-0.433Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,244.505,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.32,-0.522C0.246,-0.522 0.187,-0.484 0.156,-0.425L0.154,-0.425L0.154,-0.514L0.052,-0.514L0.052,0.17L0.158,0.17L0.158,-0.084L0.16,-0.084C0.189,-0.027 0.248,0.009 0.322,0.009C0.451,0.009 0.536,-0.094 0.536,-0.257C0.536,-0.419 0.45,-0.522 0.32,-0.522ZM0.292,-0.081C0.211,-0.081 0.157,-0.15 0.157,-0.257C0.157,-0.363 0.211,-0.433 0.292,-0.433C0.375,-0.433 0.428,-0.364 0.428,-0.257C0.428,-0.149 0.375,-0.081 0.292,-0.081Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,278.419,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.273,0.01C0.42,0.01 0.517,-0.091 0.517,-0.257C0.517,-0.422 0.419,-0.523 0.273,-0.523C0.126,-0.523 0.029,-0.422 0.029,-0.257C0.029,-0.091 0.126,0.01 0.273,0.01ZM0.273,-0.077C0.19,-0.077 0.137,-0.143 0.137,-0.257C0.137,-0.371 0.19,-0.436 0.273,-0.436C0.355,-0.436 0.409,-0.371 0.409,-0.257C0.409,-0.143 0.356,-0.077 0.273,-0.077Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,311.189,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.108,-0.597C0.142,-0.597 0.169,-0.624 0.169,-0.657C0.169,-0.691 0.142,-0.718 0.108,-0.718C0.075,-0.718 0.047,-0.691 0.047,-0.657C0.047,-0.624 0.075,-0.597 0.108,-0.597ZM0.056,-0L0.161,-0L0.161,-0.514L0.056,-0.514L0.056,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,324.203,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.052,-0L0.158,-0L0.158,-0.299C0.158,-0.379 0.206,-0.432 0.28,-0.432C0.353,-0.432 0.389,-0.389 0.389,-0.312L0.389,-0L0.495,-0L0.495,-0.333C0.495,-0.45 0.43,-0.522 0.317,-0.522C0.238,-0.522 0.183,-0.486 0.155,-0.428L0.153,-0.428L0.153,-0.514L0.052,-0.514L0.052,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,356.885,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.083,-0.635L0.083,-0.514L0.008,-0.514L0.008,-0.43L0.083,-0.43L0.083,-0.135C0.083,-0.036 0.124,0.003 0.228,0.003C0.251,0.003 0.274,0.001 0.286,-0.001L0.286,-0.085C0.279,-0.083 0.262,-0.083 0.251,-0.083C0.208,-0.083 0.189,-0.103 0.189,-0.147L0.189,-0.43L0.287,-0.43L0.287,-0.514L0.189,-0.514L0.189,-0.635L0.083,-0.635Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(60.03,0,0,60.03,376.143,119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.131,0.005C0.167,0.005 0.195,-0.023 0.195,-0.059C0.195,-0.094 0.167,-0.123 0.131,-0.123C0.096,-0.123 0.067,-0.094 0.067,-0.059C0.067,-0.023 0.096,0.005 0.131,0.005Z",
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "matrix(0.283816,0,0,0.283816,75.2989,26.6283)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761786,0,0,0.761786,52.8748,60.211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.028,46.648C505.715,44.987 502.704,44.653 500.083,45.765C500.083,45.765 106.681,203.617 27.383,238.993C21.516,241.61 18.684,254.888 24.295,258.017C46.405,270.347 160.044,312.975 160.044,312.975L160.221,312.975L160.221,313.063L203.035,462.514C204.859,468.88 213.106,471.003 217.777,466.31L306.936,375.121L427.256,422.437C437.576,426.655 449.468,419.873 451.091,408.843L511.825,55.828C512.606,52.275 511.091,48.611 508.028,46.648ZM248.761,351.464C248.78,351.251 248.801,351.011 248.938,350.846C248.998,350.775 249.229,350.845 249.203,350.934C249.14,351.155 248.939,351.319 248.761,351.464Z",
    style: {
      fill: "rgb(99,102,241)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761786,0,0,0.761786,52.8748,60.211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.935,375.122L217.776,466.311C218.815,465.18 219.572,463.819 219.983,462.339L248.761,351.465L249.202,350.935L287.514,367.001L304.64,374.24L306.935,375.122Z",
    style: {
      fill: "rgb(67,56,202)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761786,0,0,0.761786,52.8748,60.211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.681,47.124L249.203,350.934L248.938,350.846L248.761,351.464L219.983,462.338C219.572,463.818 218.816,465.179 217.776,466.31C215.568,468.528 212.35,469.411 209.319,468.631C206.288,467.851 203.897,465.523 203.034,462.514L160.22,313.063L160.22,312.975L160.132,312.975L160.132,312.887L508.681,47.124Z",
    style: {
      fill: "rgb(79,70,229)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevrijLogoCloud004);
export default __webpack_public_path__ + "static/media/levrij-logo-cloud-004.c0cd3ad313e11cfd3e68f0fa110b0575.svg";
export { ForwardRef as ReactComponent };